var render = function render(){var _vm=this,_c=_vm._self._c;return _c('patron-profile',{ref:"profile",on:{"closed":(event) => _vm.$emit('closed', event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }